import { OperacoesWebAPI } from '../../utils/global';
import api from '../api'

export const meioComunicacaoService = {

    getAll: () => {
        return api.get(`${OperacoesWebAPI.MeioComunicacao}/`,)
            .then((res) => res)
            .catch(err => err)
    },

    getComFiltros: (descricao: string = "") => {
        return api.get(`${OperacoesWebAPI.MeioComunicacao}/getcomfiltros`, { params: { descricao } })
            .then((res) => res)
            .catch(err => err)
    },

    post: (meioComunicacao: any) => {

        return api.post(`${OperacoesWebAPI.MeioComunicacao}`, meioComunicacao)
    },

    put: (meioComunicacao: any) => {
        return api.put(`${OperacoesWebAPI.MeioComunicacao}`, meioComunicacao)
    },

    delete: (meioComunicacaoID: number) => {
        return api.delete(`${OperacoesWebAPI.MeioComunicacao}?id=${meioComunicacaoID}`)
    }
}